import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, Input, inject } from '@angular/core';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { DeviceData } from '../_shared/data/device.data';
import { IRow } from '../_shared/models/table/row.model';
import { TableListComponent } from './table-list/table-list.component';
import { TableRegularComponent } from './table-regular';

@Component({
    selector: 'sirius-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TableListComponent, TableRegularComponent, CommonModule]
})
export class TableComponent implements AfterViewInit {
    breakpointObserver = inject(BreakpointObserver);

    @Input() rows: IRow[] = [];
    @Input() title = '';

    //TODO: Use device service / verify updated breakpoints did not break it
    private _breakpointMobile = `(max-width: ${DeviceData.breakpoints['md']}px)`;
    private _resize = new Subject<void>();

    private _isListTable = new BehaviorSubject<boolean>(false);
    isListTable$ = this._isListTable.asObservable();

    get columns(): number {
        return this.rows[0].cells.length;
    }

    @HostListener('window:resize')
    onResize() {
        this._resize.next();
    }

    ngAfterViewInit(): void {
        this._resize.pipe(debounceTime(250)).subscribe(() => this.setIsListTable());

        this.setIsListTable();
    }

    private setIsListTable(): void {
        this._isListTable.next(this.columns > 2 && this.isMobile());
    }

    private isMobile(): boolean {
        return this.breakpointObserver.isMatched(this._breakpointMobile);
    }
}
